"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterStatus = void 0;
/**
 * 用户注册状态
 */
var RegisterStatus;
(function (RegisterStatus) {
    RegisterStatus[RegisterStatus["UN_REGISTERED"] = 0] = "UN_REGISTERED";
    RegisterStatus[RegisterStatus["REGISTERED"] = 1] = "REGISTERED";
})(RegisterStatus = exports.RegisterStatus || (exports.RegisterStatus = {}));
